// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"ee536d68","473":"d4b84eff","787":"4062624b"}[chunkId] + ".chunk.js";
};